import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Skull, LogOut, Map, Swords, Bone, Crown } from "lucide-react";
import AudioToggle from "@/components/AudioToggle";

export default function NavBar({ active }) {
  const { auth, state, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = () => { logout(); navigate("/"); };

  const items = [
    { key: "command", label: "COMMAND", icon: Skull, to: "/command" },
    { key: "battle", label: "BATTLE", icon: Swords, to: "/battle" },
    { key: "world", label: "WORLD MAP", icon: Map, to: "/world",
      disabled: !state?.world_map_unlocked, hint: "Unlocks at 50 zombies" },
    { key: "memorial", label: "MEMORIAL", icon: Bone, to: "/memorial" },
    { key: "rebellion", label: state?.king_defeated ? "THE THRONE" : "REBELLION", icon: Crown, to: "/rebellion",
      disabled: !state?.can_rebel && !state?.king_defeated && state?.rank_index < 4,
      hint: "Crown Prince only" },
  ];

  return (
    <nav className="relative z-20 border-b border-subtle bg-void/95 backdrop-blur">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 py-4 flex items-center justify-between gap-4">
        <Link to="/command" className="flex items-center gap-3" data-testid="nav-brand-link">
          <Skull className="w-5 h-5 text-blood" />
          <span className="tac-label hidden sm:inline">ZOMBIE USURPER</span>
        </Link>

        <div className="flex items-center gap-1 sm:gap-2 overflow-x-auto">
          {items.map((it) => {
            const Icon = it.icon;
            const isActive = active === it.key;
            return (
              <Link
                key={it.key}
                to={it.disabled ? "#" : it.to}
                onClick={(e) => it.disabled && e.preventDefault()}
                className={`px-3 sm:px-4 py-2 flex items-center gap-2 transition-all whitespace-nowrap
                  ${isActive ? "text-bone border-b border-blood" : "text-muted-h hover:text-bone"}
                  ${it.disabled ? "opacity-30 cursor-not-allowed" : ""}`}
                title={it.disabled ? it.hint : ""}
                data-testid={`nav-${it.key}-link`}
              >
                <Icon className="w-3.5 h-3.5" />
                <span className="text-[0.65rem] tracking-[0.2em] uppercase">{it.label}</span>
              </Link>
            );
          })}
        </div>

        <div className="flex items-center gap-3">
          <div className="hidden md:flex flex-col items-end leading-tight">
            <span className="tac-label" data-testid="nav-callsign">{auth?.callsign}</span>
            {state?.active_title && (
              <span className="text-[0.6rem] tracking-[0.2em] text-blood mt-0.5"
                    data-testid="nav-active-title">{state.active_title}</span>
            )}
          </div>
          <Link to="/new-game" className="btn-ghost flex items-center gap-1" data-testid="nav-new-game-button">
            NEW GAME
          </Link>
          <AudioToggle />
          <button onClick={onLogout} className="btn-ghost flex items-center gap-1" data-testid="nav-logout-button">
            <LogOut className="w-3 h-3" /> EXIT
          </button>
        </div>
      </div>
    </nav>
  );
}
